import { useMemo } from 'react';
function setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
}
/**
 * Merge two React refs into single one in a stable way.
 *
 * Useful when the ref received via props must be combined with internal component ref.
 *
 * @param refA Initial ref
 * @param refB Secondary ref
 * @returns A function that receives the element and assign the value to the given refs
 */
function useMergeRefs(refA, refB) {
    return useMemo(function () {
        if (refA == null && refB == null) {
            return null;
        }
        return function (refValue) {
            setRef(refA, refValue);
            setRef(refB, refValue);
        };
    }, [refA, refB]);
}
export default useMergeRefs;
